import { logger as garnishLogger } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = garnishLogger.extend('SWEETPASS_CHECKOUT_MACHINE');
